export default __webpack_public_path__ + "static/media/search.3b8c1143.svg";